'use client';
import React, { useState } from 'react';
import ElephantQuestionIcon from '@/components/Icon/ElephantQuestionIcon';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { FaqModal } from './FaqModal';

const HelpChatBox = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);

  return (
    <>
      <FaqModal handleFaqModalClose={() => setIsModalOpen(false)} isOpen={isModalOpen} />
      <aside className="fixed bottom-5 right-5 z-50 flex flex-col justify-end gap-5 lg:flex-row xl:flex-row">
        {isOpen && (
          <div className="flex flex-col items-end justify-center gap-2 lg:flex-row lg:items-start xl:flex-row xl:items-start">
            <div className="flex size-6 cursor-pointer items-center justify-center rounded-full border-2 border-white bg-gradient-to-r from-primary to-secondary text-white">
              <button onClick={() => setIsOpen(false)}>
                <XMarkIcon className="size-4 text-white" />
              </button>
            </div>
            <FaqButton openModal={openModal}>
              <div className="rounded-md bg-white px-3 py-2">
                <p className="text-black">Have questions?</p>
                <p className="text-gray-3">We have answers.</p>
              </div>
            </FaqButton>
          </div>
        )}
        <div className="mr-0 flex size-14 items-center justify-center self-end rounded-md bg-gradient-to-r from-primary to-secondary p-3 lg:m-auto xl:m-auto">
          <FaqButton openModal={openModal}>
            <ElephantQuestionIcon />
          </FaqButton>
        </div>
      </aside>
    </>
  );
};

function FaqButton({ children, openModal }: { children: React.ReactNode; openModal: () => void }) {
  return <button onClick={openModal}>{children}</button>;
}

export default HelpChatBox;
